import { render } from "./LuxuryTravel01.vue?vue&type=template&id=57171680&scoped=true"
import script from "./LuxuryTravel01.vue?vue&type=script&lang=js"
export * from "./LuxuryTravel01.vue?vue&type=script&lang=js"

import "./LuxuryTravel01.scss?vue&type=style&index=0&id=57171680&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57171680"]])

export default __exports__